"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var _excluded = ["direction", "wrap", "gap", "order", "grow", "shrink", "basis", "children"],
    _excluded2 = ["justifyContent", "alignItems", "alignContent", "alignSelf"];

var DxcFlex = function DxcFlex(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "row" : _ref$direction,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? "nowrap" : _ref$wrap,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? "0" : _ref$gap,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? 0 : _ref$grow,
      _ref$shrink = _ref.shrink,
      shrink = _ref$shrink === void 0 ? 1 : _ref$shrink,
      _ref$basis = _ref.basis,
      basis = _ref$basis === void 0 ? "auto" : _ref$basis,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Flex, (0, _extends2["default"])({
    $direction: direction,
    $wrap: wrap,
    $order: order,
    $grow: grow,
    $shrink: shrink,
    $basis: basis,
    $gap: gap
  }, props), children);
};

var Flex = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", "\n"])), function (_ref2) {
  var _ref2$justifyContent = _ref2.justifyContent,
      justifyContent = _ref2$justifyContent === void 0 ? "flex-start" : _ref2$justifyContent,
      _ref2$alignItems = _ref2.alignItems,
      alignItems = _ref2$alignItems === void 0 ? "stretch" : _ref2$alignItems,
      _ref2$alignContent = _ref2.alignContent,
      alignContent = _ref2$alignContent === void 0 ? "normal" : _ref2$alignContent,
      _ref2$alignSelf = _ref2.alignSelf,
      alignSelf = _ref2$alignSelf === void 0 ? "auto" : _ref2$alignSelf,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return "\n    flex-direction: ".concat(props.$direction, "; \n    flex-wrap: ").concat(props.$wrap, "; \n    justify-content: ").concat(justifyContent, "; \n    align-items: ").concat(alignItems, ";\n    align-content: ").concat(alignContent, ";\n    align-self: ").concat(alignSelf, ";\n    gap: ").concat((0, _typeof2["default"])(props.$gap) === "object" ? "".concat(props.$gap.rowGap, " ").concat(props.$gap.columnGap) : props.$gap, ";\n    order: ").concat(props.$order, ";\n    flex-grow: ").concat(props.$grow, ";\n    flex-shrink: ").concat(props.$shrink, ";\n    flex-basis: ").concat(props.$basis, ";\n  ");
});

var _default = DxcFlex;
exports["default"] = _default;